import restApi from "@plannel/services/utils/rest-api";

const getAll = params => {
  return restApi.post("/api/suppliers-item", params);
};

const getAllForCSV = params => {
  return restApi.post("/api/suppliers-item/csv", params);
};

const getForItem = (params) => {
  return restApi.get("/api/suppliers-item/item", { params });
};

const upsert = data => {
  return restApi.post("/api/suppliers-item/save", data);
};

const remove = ids => {
  return restApi.delete(`/api/suppliers-item/${ids}`);
};


const supplierItemService = {
  getAll,
  getAllForCSV,
  getForItem,
  upsert,
  remove,
};

export default supplierItemService;